import { makeRequest } from "@/common/classes/ApiUtils";
import { Content } from "@/features/contents/classes/ContentModel";

/**
 * Create a Content record.
 *
 * @param   {Content} content
 * @return  {Promise}
 */
export const requestCreateContent = (content: Content) => {
  return makeRequest({
    url: `/api/v1/contents`,
    body: content,
    method: "POST",
  });
};

/**
 * Delete a Content record.
 *
 * @param   {number} contentId
 * @return  {Promise}
 */
export const requestDeleteContent = (contentId: number) => {
  return makeRequest({
    url: `/api/v1/contents/${contentId}`,
    method: "DELETE",
  });
};

/**
 * Update a Content record.
 *
 * @param   {string}  contentMachineName
 * @param   {Object}  content
 * @return  {Promise}
 */
export const requestUpdateContent = (contentId: number, content: Content) => {
  return makeRequest({
    url: `/api/v1/contents/${contentId}`,
    body: content,
    method: "PUT",
  });
};

/**
 * Get single content record.
 *
 * @param   {Object}  params
 * @return  {Promise}
 */
export const requestContent = (contentId: number) =>
  makeRequest({
    url: `/api/v1/contents/${contentId}`,
    method: "GET",
  });

/**
 * Get multiple content records.
 *
 * Returned records are dependent on user's access to them.
 *
 * @param   {Object}  params
 * @return  {Promise}
 */
export const requestContents = (params: object) =>
  makeRequest({
    url: "/api/v1/contents",
    body: params,
    method: "GET",
  });

/**
 * Get content based on machine name
 *
 * @param   {Object}  params
 * @return  {Promise}
 */
export const requestContentsShow = (params: object) =>
  makeRequest({
    url: "/api/v1/contents-show",
    body: params,
    method: "GET",
  });

/**
 * Get files
 *
 * @param   {Object}  params
 * @return  {Promise}
 */
export const requestFiles = (params: object) =>
  makeRequest({
    url: "/api/v1/files",
    body: params,
    method: "GET",
  });
